/**
 * Match all emojis using the [Extended_Pictographic](https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt) matcher to select a wider selection of emojis
 */
const EmojiRegexMatcher =
  /^(\p{Extended_Pictographic}|\p{Emoji_Presentation})/iu;
export const isEmoji = (node: any) =>
  typeof node === 'string' && EmojiRegexMatcher.test(node);
